<template>
  <div v-if="showCategories">
    <div class="categories-filter__section-title">
      <h4>
        Coleções disponíveis
        <span
          v-if="
            lastSelectedCategory ||
            (selectedCategory && selectedCategory.children.length)
          "
        >
          em
          <b>
            {{
              selectedCategory && selectedCategory.children.length
                ? selectedCategory.name
                : lastSelectedCategory && lastSelectedCategory.name
            }}
          </b>
        </span>
      </h4>
    </div>

    <div class="categories-filter__categories-container">
      <div
        ref="categoriesContainer"
        :class="[
          'categories-filter__categories',
          { 'categories-filter__categories--mobile': isMobile },
        ]"
      >
        <transition name="fade">
          <div>
            <row-items-skeleton-loading v-if="!categoriesToShow.length" />
            <button
              v-for="category in categoriesToShow"
              :key="category.id"
              :class="[
                'categories-filter__categories-item',
                {
                  'categories-filter__categories-item--active': isCategorySelected(
                    category
                  ),
                },
              ]"
              @click="onSelectCategory(category)"
            >
              {{ category.name }}
            </button>
          </div>
        </transition>
      </div>
    </div>

    <div v-if="shouldShowArrows" class="categories-filter__nav">
      <button
        class="categories-filter__nav-item categories-filter__nav-item--left"
        :class="{
          'categories-filter__nav-item--hide': shouldHideLeftArrow,
        }"
        @click="navGallery(1)"
      >
        <ArrowLeft class="categories-filter__arrow" />
      </button>
      <button
        class="categories-filter__nav-item categories-filter__nav-item--right"
        @click="navGallery(-1)"
      >
        <ArrowRight class="categories-filter__arrow" />
      </button>
    </div>
  </div>
</template>

<script>
import RowItemsSkeletonLoading from '@/components/loadings/skeleton/RowItemsSkeletonLoading.vue'
import ArrowLeft from '~/components/icons/arrow-left/ArrowLeft'
import ArrowRight from '~/components/icons/arrow-right/ArrowRight'
import scrollingNavigator from '~/mixins/scrolling-navigator'

export default {
  name: 'CategoriesFilter',
  components: {
    RowItemsSkeletonLoading,
    ArrowLeft,
    ArrowRight,
  },
  mixins: [scrollingNavigator],
  props: {
    categoriesToShow: {
      type: Array,
      default: () => [],
    },
    selectedCategory: {
      type: Object,
      default: null,
    },
    selectedCategories: {
      type: Array,
      default: () => [],
    },
    showCategories: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    listClassName: {
      type: String,
      default: 'categories-filter__categories',
    },
  },
  computed: {
    lastSelectedCategory() {
      return this.selectedCategories?.length >= 2
        ? this.selectedCategories[this.selectedCategories.length - 2]
        : null
    },
    shouldShowArrows() {
      return !this.isMobile && this.categoriesToShow.length
    },
    shouldHideLeftArrow() {
      return !this.translateX || this.translateX === 0 || this.isMobile
    },
    isCategorySelected() {
      return (category) =>
        this.selectedCategories.some((cat) => cat.id === category.id)
    },
  },
  watch: {
    selectedCategory(newVal) {
      if (newVal) {
        this.autoScrollToSelectedCategory({
          refName: 'categoriesContainer',
          isMobile: this.isMobile,
        })
      }
    },
    categoriesToShow(newVal) {
      if (newVal.length) {
        this.autoScrollToSelectedCategory({
          refName: 'categoriesContainer',
          isMobile: this.isMobile,
        })
      }
    },
  },
  methods: {
    onSelectCategory(category) {
      this.$emit('select-category', category)
    },
  },
}
</script>

<style lang="scss" scoped>
.categories-filter {
  &__section-title {
    margin-top: 20px;
    margin-bottom: 10px;

    h4 {
      font-weight: 500;
      font-size: 15px;
    }
  }

  &__categories-container {
    overflow: hidden;
    margin-left: -15px;
    padding-left: 15px;
    margin-right: -15px;
    padding-right: 15px;
  }

  &__categories {
    overflow: visible;
    white-space: nowrap;
    transition: transform 400ms cubic-bezier(0.165, 0.84, 0.44, 1);
    margin-left: -15px;
    padding-left: 15px;
    margin-right: -15px;
    padding-right: 15px;

    &--mobile {
      overflow: auto;
    }

    &-item {
      display: inline-block;
      margin-right: 10px;
      white-space: nowrap;
      background: none;
      font-weight: bold;
      border-radius: 3px;
      border: 1px solid $v4_color_primary;
      padding: 5px 10px;
      height: 35px;
      cursor: pointer;
      font-size: 15px;
      transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;

      &:hover {
        background: $v4_color_primary_light;
      }

      &--active {
        background: $v4_color_primary_light;

        &:hover {
          background: $v4_color_primary_light;
        }
      }

      @media (max-width: $v4_desktop) {
        &:hover {
          background: none;
        }

        &--active {
          background: $v4_color_primary_light;

          &:hover {
            background: $v4_color_primary_light;
          }
        }
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }

  &__nav {
    display: flex;
    justify-content: space-between;
    margin-top: -37px;

    .categories-filter__arrow {
      width: 25px;
      fill: $v4_color_blue;
      transition: all 0.2s ease-in-out;
    }

    &-item {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 0;
      background-color: $color-light-gray-transparent;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 5;

      &--left {
        margin-left: -15px;
      }

      &--right {
        margin-right: -15px;
      }

      &:hover {
        background-color: $color-light-gray;
      }

      &--hide {
        opacity: 0;
      }
    }
  }
}
</style>
